// src/modules/app-views/products/pages/Init/components/tableColumns/statusColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function statusColumn(buildColumnProps, options = {}) {
  const {
    key = 'status',
    title = 'status',
    dataIndex = 'status',
    width = 100,
    align = 'center',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const status = r?.status || 'active';
      const cfg = {
        active: { color: 'success', label: 'active' },
        inactive: { color: 'default', label: 'inactive' },
        discontinued: { color: 'error', label: 'discontinued' },
      };
      const { color, label } = cfg[status] || { color: 'default', label: status };
      return <Tag color={color}>{translateX(label)}</Tag>;
    },
  };
}

export default statusColumn;
